import { Component, inject, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { UserLoginSed } from "src/app/shared/models/sed/UserLogin";
//Modelos
import { ChamadosUsuario } from "src/app/shared/models/chamados/chamadosUsuario";
//Services
import { CommonModule } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { StatusJornada } from 'src/app/shared/enums/Jornada/StatusJornada';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { JornadaPsicologo } from 'src/app/shared/models/psicologo/JornadaPsicologo';
import { RelogioPontoService } from "src/app/shared/services/modal-relogioPonto.service";
import { PsicologoService } from 'src/app/shared/services/psicologo.service';
import { ModalRegistroFimComponent } from './modal-registro-fim/modal-registro-fim.component';
import { ModalRegistroInicioComponent } from './modal-registro-inicio/modal-registro-inicio.component';

@Component({
  selector: 'relogio-ponto-component',
  templateUrl: './relogio-ponto.component.html',
  styleUrls: ['./relogio-ponto.component.scss'],
  standalone: true,
  imports: [CommonModule,ModalRegistroInicioComponent,ModalRegistroFimComponent]
})

export class RelogioPontoComponent {
  //Injeções
  private authService = inject(AuthService);
  private spinnerService = inject(NgxSpinnerService);
  private toastr = inject(ToastrService);
  private relogioPontoService = inject(RelogioPontoService);
  private psicologoService = inject(PsicologoService)
  private router = inject(Router);

  public userLogado: UserLoginSed | null;

  public chamadosUsuario: ChamadosUsuario;
  public visualizarInformacoes: boolean = true;
  public outroDia: boolean = false;

  JornadaAtiva: JornadaPsicologo | null = null;

  StatusJornada: Signal<number> = this.relogioPontoService.statusJornada;

  get HorarioForaDaJornadaPadrao(): boolean {
    return new Date().getHours() > 18 ||
      new Date().getHours() < 8
  };

  constructor() {
    this.userLogado = this.authService.getUser();

  }

  public async ngOnInit() {
    await this.getJornadaEmAberto();
  }

  async abrirModal(): Promise<void> {
    this.userLogado = this.authService.getUser();
    if (this.validaDiretoriaEscola()) {
      await this.getJornadaEmAberto();
      if (this.JornadaAtiva && !this.outroDia)
        this.router.navigate(['/registro-saida'], { queryParams: { flow: 'checkout' } });
      else
        this.relogioPontoService.abrirModalIniciarJornada();
    } else {
      this.toastr.error("Para registrar o ponto é necessário estar vinculado a uma escola e diretoria, ou selecionar apenas a diretoria.",
        "Erro");
    }

  }
  validaDiretoriaEscola(): boolean {
    const codigoDiretoria = this.userLogado?.codigoDiretoria ?? 0;
    if (codigoDiretoria == 0) {
      return false;
    }

    // Coordenador é vinculado à URE (escola 0). O registro de ponto usa a diretoria.
    if (this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo) {
      return true;
    }

    return (this.userLogado?.codigoEscola != 0 && !this.userLogado?.apenasDiretoria)
      || ((this.userLogado?.codigoEscola == 0 || this.userLogado?.codigoEscola == null) && this.userLogado?.apenasDiretoria);
  }



  async getJornadaEmAberto() {
    this.spinnerService.show();
    this.outroDia = false;
    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(this.userLogado?.cpf!));
      if (!response.isSucess) {
        this.toastr.error(response.message, response.title);
        this.spinnerService.hide();
        return;
      }
      if (response.data !== null) {

        this.JornadaAtiva = response.data;

        const dataInicioJornada = new Date(response.data.dataInicio);
        const hoje = new Date();
        const inicioDiaHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        const inicioDiaJornada = new Date(dataInicioJornada.getFullYear(), dataInicioJornada.getMonth(), dataInicioJornada.getDate());
        const diffDias = Math.floor((inicioDiaHoje.getTime() - inicioDiaJornada.getTime()) / (24 * 60 * 60 * 1000));

        // Se a jornada está em aberto, o status do topo deve permanecer "em andamento" (verde),
        // mesmo se for de dia anterior.
        this.relogioPontoService.updateStatusJornada(StatusJornada.EmAndamento);
        this.outroDia = diffDias > 0;
      } else {
        this.JornadaAtiva = null;
        this.relogioPontoService.updateStatusJornada(StatusJornada.NaoIniciada);
      }
    } catch (error: any) {
      const mensagem =
        error?.error?.message
        || error?.message
        || 'Não foi possível consultar o status da jornada. Tente novamente.';
      this.toastr.error(mensagem, 'Erro');
    } finally {
      this.spinnerService.hide();
    }
  }
}
